import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import img from '../../../assets/physiotherapist-and-boy-holding-ball-pxfq-9-hy.png';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1rem 0',
    width: '100%',
    height: '100%',
  },
  img: {
    maxHeight: '16rem',
    maxWidth: '90vw',
    objectFit: 'contain',
  },
}));

const TitleImage = ({data}) => {
  const classes = useStyles();
  const imageSize = '@1280x720';
  const profileImg = data.image_path ? data.image_path + imageSize : img;
  return (
    <div className={classes.root}>
      <img
        src={profileImg}
        alt={`Provider ${data.name} logo`}
        className={classes.img}
        aria-label="Provider headline image"
      />
    </div>
  );
};

TitleImage.propTypes = {
  data: PropTypes.object,
};

export default TitleImage;
